import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "./InnerhandPicked2SliderCard.css";
import { Link } from 'react-router-dom';

export const InnerhandPicked2SliderCards = () => {
    return (
        <>
            <h1 className="text-center text-success my-5 "></h1>
            {/* //  <button className="btn btn-danger">Danger button</button> */}
            <div className="container">
                <div className="row InnerhandPicked1SliderCardsmainDiv">
                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>
                    

                </div><br/><br/>

                <div className="row InnerhandPicked1SliderCardsmainDiv">
                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>
                    

                </div><br/><br/>

                <div className="row InnerhandPicked1SliderCardsmainDiv">
                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div className="col-md-4 ho InnerhandPicked1SliderCardsContainer">
                    <Link to="/baliDetails" style={{textDecoration:"none",color:"black"}}>
                        <div className="card InnerhandPicked1SliderCardsDataContainer">
                            <img className="card-img-top" src="Images/SubPagesBackgroundImages/place1.webp" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title InnerhandPicked1SliderCardsTitle">Royal caribbean transatiantic cruise</h5>
                                <p className="card-text InnerhandPicked1SliderCardsdetails">Royal Caribbean Group, formerly known as Royal Caribbean Cruises Ltd., is a global cruise holding
                                      company incorporated in Liberia and based in Miami
                                       Florida.</p>

                                <a href="#" className="btn btn-primary InnerHandpicked1SliderButton">Explore</a>
                            </div>
                        </div>
                        </Link>
                    </div>
                    

                </div><br/><br/>
                

                

                
            </div>
            

            
        </>
    )
}